module.exports = __webpack_public_path__ + "static/img/gaozhonghuaxue6.10bba352.jpg";